import React from "react";
import {
  TextField,
  Button,
  Card,
  CardContent,
  CardHeader,
  MenuItem,
  Box,
  Divider,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import VisibilityIcon from "@mui/icons-material/Visibility";

function LawFirmDetailsFormCard({
  lawFirmData,
  setLawFirmData,
  role,
  internalUsers,
  isEditing,
  isSaving,
  handleViewLawFirmBonds,
  handleEditClick,
  handleCancelClick,
  handleSave,
  formatDateForInput,
}) {
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Card
        elevation={3}
        sx={{
          borderRadius: "16px",
          height: "fit-content",
        }}
      >
        <CardHeader
          title="Law Firm Details"
          sx={{
            backgroundColor: "#1976d2", // Consistent blue theme
            color: "white",
            "& .MuiCardHeader-title": {
              fontSize: "1.5rem",
              fontWeight: "600",
            },
          }}
          action={
            <Button
              variant="contained"
              onClick={handleViewLawFirmBonds}
              startIcon={<VisibilityIcon />}
              sx={{
                fontWeight: 600,
                borderRadius: "20px",
                backgroundColor: "white",
                color: "#1976d2",
                boxShadow: "none",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#bbdefb",
                  boxShadow: "none",
                },
              }}
            >
              View Law Firm Bonds
            </Button>
          }
        />
        <CardContent sx={{ padding: 3 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
              <TextField
                label="Law Firm Name"
                name="name"
                fullWidth
                variant="outlined"
                value={lawFirmData.name || ""}
                onChange={(e) =>
                  setLawFirmData({ ...lawFirmData, name: e.target.value })
                }
                disabled={!isEditing}
              />
            </Grid>
            {/* Managed by */}
            {(role === "super_user" || role === "internal_user") && (
              <Grid size={{ xs: 12 }}>
                <TextField
                  select
                  label="Managed By"
                  name="managed_by"
                  fullWidth
                  variant="outlined"
                  value={lawFirmData.managed_by || ""}
                  onChange={(e) =>
                    setLawFirmData({
                      ...lawFirmData,
                      managed_by: e.target.value,
                    })
                  }
                  disabled={!isEditing}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {internalUsers.map((user) => (
                    <MenuItem
                      key={user.internal_user_id}
                      value={user.internal_user_id}
                    >
                      {user.full_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label="Website"
                name="website"
                fullWidth
                variant="outlined"
                value={lawFirmData.website || ""}
                onChange={(e) =>
                  setLawFirmData({
                    ...lawFirmData,
                    website: e.target.value,
                  })
                }
                disabled={!isEditing}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label="Date of First Bond"
                name="first_bond_date"
                type="date"
                fullWidth
                variant="outlined"
                value={formatDateForInput(lawFirmData.first_bond_date)}
                onChange={(e) =>
                  setLawFirmData({
                    ...lawFirmData,
                    first_bond_date: e.target.value,
                  })
                }
                slotProps={{ inputLabel: { shrink: true }}}
                disabled={!isEditing}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label="Accounting Contact Full Name"
                name="accountingContactName"
                fullWidth
                variant="outlined"
                value={lawFirmData.accounting_contact_full_name || ""}
                onChange={(e) =>
                  setLawFirmData({
                    ...lawFirmData,
                    accounting_contact_full_name: e.target.value,
                  })
                }
                disabled={!isEditing}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label="Accounting Contact Email"
                name="accountingContactEmail"
                fullWidth
                variant="outlined"
                value={lawFirmData.accounting_contact_email || ""}
                onChange={(e) =>
                  setLawFirmData({
                    ...lawFirmData,
                    accounting_contact_email: e.target.value,
                  })
                }
                disabled={!isEditing}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextField
                label="Accounting Contact Phone"
                name="accountingContactPhone"
                fullWidth
                variant="outlined"
                value={lawFirmData.accounting_contact_phone || ""}
                onChange={(e) =>
                  setLawFirmData({
                    ...lawFirmData,
                    accounting_contact_phone: e.target.value,
                  })
                }
                disabled={!isEditing}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 3 }} />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            {isEditing ? (
              <>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleCancelClick}
                  sx={{ minWidth: 100 }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  disabled={isSaving}
                  sx={{ minWidth: 100 }}
                >
                  {isSaving ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={handleEditClick}
                sx={{ minWidth: 100 }}
              >
                Edit
              </Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default LawFirmDetailsFormCard;
